import { WebLabConfig, WeblabManager } from "src/shared/WeblabManager";
import { KatalWebSellerCentralClient, WeblabType } from "@amzn/katal-weblab-sellercentral";
import { KatalWeblabClient, Weblab } from "@amzn/katal-weblab";

const weblabProxy = new KatalWebSellerCentralClient();
const client = new KatalWeblabClient({ weblabProxy });

interface VibesWeblabConfig extends WebLabConfig {
    EligibilityApiLaunch: Weblab;
    PulseApiLaunch: Weblab;
}

export type VibesWebLabNames = keyof VibesWeblabConfig;

const config: VibesWeblabConfig = {
    EligibilityApiLaunch: {
        defaultTreatment: "C",
        id: "VIBES_ELEGIBILITY_API_LAUNCH_415878",
        weblabType: WeblabType.Customer,
    },
    PulseApiLaunch: {
        defaultTreatment: "C",
        id: "PULSE_984652",
        weblabType: WeblabType.Customer
    }
};

export const manager = new WeblabManager(config, client);